
const RecivedChecklist = () => {
  return (
    <div>
      
    </div>
  )
}

export default RecivedChecklist
